import { render } from "./recommend-packgage-dialog.vue?vue&type=template&id=6e9beaf1&scoped=true"
import script from "./recommend-packgage-dialog.vue?vue&type=script&lang=js"
export * from "./recommend-packgage-dialog.vue?vue&type=script&lang=js"

import "./recommend-packgage-dialog.vue?vue&type=style&index=0&id=6e9beaf1&lang=scss&scoped=true"

import exportComponent from "/root/workspace/zyy-iot_zyy-iot-web-v2_Ejzw/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e9beaf1"]])

export default __exports__